import React, { useState } from 'react';
import Select from 'react-select';

function SurahAayaat(props) {
    const { aayaat, handleAyatChange } = props;

    const ayahOptions = aayaat.map(item => ({
        value: item.ayatNum,
        label: item.ayatNum.toString()
    }));

    const [surahayatNum, setSurahayatNum] = useState(null);

    return (
        <>
            <div style={{ float: "left", paddingLeft: '15px' }}>
                {ayahOptions.length > 0 && (
                    <>
                        <Select
                            options={ayahOptions}
                            value={surahayatNum}
                            onChange={(selected) => {
                                setSurahayatNum(selected);
                                handleAyatChange(selected);
                            }}
                            placeholder="Choose Ayah"
                            isClearable
                            isMulti
                        />
                    </>
                )}
            </div>
            <div style={{ float: "left", paddingLeft: '15px' }}>
                {ayahOptions.length > 0 && (
                    <span className={"total-aayaat-count"}>Total Aayaat: {ayahOptions.length}</span>
                )}
            </div >
        </>
    );
}

export default SurahAayaat;
